import { z } from 'zod';
export var CaptchaType;
(function (CaptchaType) {
    CaptchaType["RecaptchaEnterprise"] = "RecaptchaEnterprise";
    CaptchaType["Turnstile"] = "Turnstile";
    CaptchaType["AliyunCaptcha"] = "AliyunCaptcha";
})(CaptchaType || (CaptchaType = {}));
export var RecaptchaEnterpriseMode;
(function (RecaptchaEnterpriseMode) {
    RecaptchaEnterpriseMode["Invisible"] = "invisible";
    RecaptchaEnterpriseMode["Checkbox"] = "checkbox";
})(RecaptchaEnterpriseMode || (RecaptchaEnterpriseMode = {}));
export const turnstileConfigGuard = z.object({
    type: z.literal(CaptchaType.Turnstile),
    siteKey: z.string(),
    secretKey: z.string(),
});
export const recaptchaEnterpriseConfigGuard = z.object({
    type: z.literal(CaptchaType.RecaptchaEnterprise),
    siteKey: z.string(),
    secretKey: z.string(),
    projectId: z.string(),
    domain: z.string().optional(),
    mode: z.nativeEnum(RecaptchaEnterpriseMode).optional(),
});
/**
 * 阿里云验证码 2.0（无痕/滑块）。前端只需 prefix（身份标）+ sceneId（场景ID）+ region；
 * accessKeyId/accessKeySecret 仅服务端调 VerifyIntelligentCaptcha 用，绝不下发前端（见 findCaptchaPublicConfig）。
 * region 决定服务端 endpoint 与前端 JS 区域：cn（华东，captcha.cn-shanghai.aliyuncs.com）/ sgp（新加坡）。
 * region 为必填（不设 .default，避免 input/output 类型不一致导致 db-entries 代码生成失败）；表单默认 cn。
 */
export const aliyunCaptchaConfigGuard = z.object({
    type: z.literal(CaptchaType.AliyunCaptcha),
    prefix: z.string(),
    sceneId: z.string(),
    accessKeyId: z.string(),
    accessKeySecret: z.string(),
    region: z.enum(['cn', 'sgp']),
});
export const captchaConfigGuard = z.discriminatedUnion('type', [
    turnstileConfigGuard,
    recaptchaEnterpriseConfigGuard,
    aliyunCaptchaConfigGuard,
]);
